var map = {
	"./DS/DS-M-6.svg": "44bd",
	"./Default/Default-M-6.svg": "d1ba",
	"./ES/ES-M-6.svg": "8f81",
	"./ES/old/ES-M-6.svg": "7357",
	"./KMS/KMS-M-6.svg": "3e8d",
	"./LS/LS-M-6.svg": "7580",
	"./MS/MS-M-6.svg": "158c",
	"./NS/NS-M-6.svg": "57d2",
	"./OKIS/OKIS-M-6.svg": "23a0",
	"./PS/PS-M-6.svg": "e7de",
	"./PSSS/PSSS-M-6.svg": "08b6",
	"./RS/RS-M-6.svg": "47486",
	"./SSS/SSS-M-6.svg": "05e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d02";